import React, { lazy, Suspense, useMemo } from 'react';

import { useSelector } from 'react-redux';
import { envIsMexico, envIsNormal } from '@/constants/constants';
import { selectLocale } from '@/store/selectors/commonSelectors';
import GamesLobbyThailand from '@/pages/games/lobby/GamesLobbyThailand';

const GamesLobbyMexico = lazy(() => import('./GamesLobbyMexico'));
const GamesLobbyNormal = lazy(() => import('./GamesLobbyNormal'));

function GamesLobby(): JSX.Element {
  const locale = useSelector(selectLocale);

  const LobbyComponent = useMemo(() => {
    if (envIsMexico()) {
      return <GamesLobbyMexico />;
    }

    if (envIsNormal() && locale === 'th') {
      return <GamesLobbyThailand />;
    }

    return <GamesLobbyNormal />;
  }, [locale]);

  return <Suspense fallback={<div className="w-full min-h-[100vh]" />}>{LobbyComponent}</Suspense>;
}

export default GamesLobby;
